/* ============================================================================
   ENGORI — Warenkorb: Zugabe-Angebot (Upsell)
   ----------------------------------------------------------------------------
   Angelegt 28.09.2026. Gegenstueck zu snippets/engori-cart-upsell.liquid und
   zum Abschnitt "Warenkorb-Zugabe" am Ende von assets/engori-cart.css.

   Zwei Aufgaben:
     1. Farbwahl (Knopfgruppe mit role="radio"): Markierung, Pfeiltasten,
        Bild, Farbname und Preis nachziehen.
     2. Dazulegen ohne Seitenwechsel: cart/add.js, danach die beiden
        Warenkorb-Sections ueber die Section Rendering API neu holen.

   WARUM ALLE ZUHOERER AM DOKUMENT HAENGEN
   Der Block liegt innerhalb von `#main-cart-items .js-contents`. Das externe
   Shrine-Skript ersetzt diesen Bereich nach JEDER Mengenaenderung durch
   frisches Markup. Ein direkt am Element gesetzter Zuhoerer waere danach weg,
   und ein <script> im ersetzten Markup wird von innerHTML nie ausgefuehrt.
   Deshalb: Delegation am Dokument, und kein Zustand im Speicher — was gilt,
   steht im Markup (aria-checked).

   Das Skript scheitert still, wenn sein Block fehlt.
   ========================================================================= */
(function () {
  'use strict';

  /* Locale-Praefix beachten (/de/cart statt /cart), sonst antwortet Shopify je
     nach Sprachdomain mit einer Weiterleitung statt mit JSON. Dieselbe Regel
     wie in assets/engori-cart.js. */
  function wurzel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function kugeln(block) {
    return Array.prototype.slice.call(block.querySelectorAll('[data-eng-ups-kugel]'));
  }

  function gewaehlte(block) {
    return block.querySelector('[data-eng-ups-kugel][aria-checked="true"]');
  }

  /* ==========================================================================
     1. Farbwahl
     ====================================================================== */

  function waehlen(block, ziel) {
    if (!ziel || ziel.disabled) return;

    kugeln(block).forEach(function (kugel) {
      var an = kugel === ziel;
      kugel.setAttribute('aria-checked', an ? 'true' : 'false');
      /* Roving tabindex: die Gruppe ist EINE Station in der Tabulatorfolge,
         innerhalb wird mit den Pfeiltasten gewechselt. */
      kugel.tabIndex = an ? 0 : -1;
    });

    var bild = block.querySelector('[data-eng-ups-bild]');
    var bildQuelle = ziel.getAttribute('data-bild');
    if (bild && bildQuelle) {
      bild.removeAttribute('srcset');
      bild.src = bildQuelle;
    }

    var farbe = block.querySelector('[data-eng-ups-farbe]');
    if (farbe) farbe.textContent = ziel.getAttribute('data-farbe') || '';

    /* Preise: nur umschalten, nichts formatieren.
       Jede Variante hat ihren fertigen Betrag im Markup — gesetzt von Liquid
       mit dem money-Filter und, wo noetig, von assets/engori-euro.js auf
       "24,95 €" gedreht. Wuerde dieses Skript einen Betrag selbst in die Seite
       schreiben, stuende dort das Rohformat "€24,95". Begruendung ausfuehrlich
       im Snippet. */
    var kennung = ziel.getAttribute('data-id');
    Array.prototype.forEach.call(block.querySelectorAll('[data-eng-ups-preis]'), function (spanne) {
      spanne.hidden = spanne.getAttribute('data-eng-ups-preis') !== kennung;
    });
  }

  function nachbar(block, ziel, richtung) {
    var offene = kugeln(block).filter(function (kugel) {
      return !kugel.disabled;
    });
    if (!offene.length) return null;

    var stelle = offene.indexOf(ziel);
    if (stelle === -1) return offene[0];

    var neu = (stelle + richtung + offene.length) % offene.length;
    return offene[neu];
  }

  /* ==========================================================================
     2. Dazulegen
     --------------------------------------------------------------------------
     Nach dem Hinzufuegen muessen ZWEI Sections neu gerechnet werden: die
     Postenliste und die Summenbox. Beide werden in einem Abruf geholt
     (?sections=a,b) und jeweils in ihrem `.js-contents` ersetzt — genau die
     Stelle, die auch das Shrine-Skript austauscht.

     Die Kennungen werden aus dem `data-id` der Section gelesen, nicht
     hineingeschrieben: in dieser Vorlage heissen die Sections "cart-items" und
     "cart-footer", nicht "main-cart-items". Wer sie im Theme-Editor umbenennt
     oder neu anlegt, aendert die Kennung — das Attribut bleibt richtig.

     Geht dabei irgendetwas nicht auf, wird die Seite neu geladen. Ein
     halb ersetzter Warenkorb ist schlimmer als ein Neuaufbau.
     ====================================================================== */

  function abschnitte() {
    var paare = [];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.getAttribute('data-id')) {
        paare.push({ el: el, kennung: el.getAttribute('data-id') });
      }
    });
    return paare;
  }

  function auffrischen() {
    var paare = abschnitte();
    if (!paare.length) {
      window.location.reload();
      return Promise.resolve();
    }

    var kennungen = paare
      .map(function (paar) {
        return paar.kennung;
      })
      .join(',');

    return fetch(wurzel() + 'cart?sections=' + encodeURIComponent(kennungen))
      .then(function (res) {
        if (!res.ok) throw new Error('Sections nicht erreichbar');
        return res.json();
      })
      .then(function (daten) {
        var zerleger = new DOMParser();

        paare.forEach(function (paar) {
          var roh = daten[paar.kennung];
          if (!roh) throw new Error('Section ' + paar.kennung + ' fehlt');

          var frisch = zerleger.parseFromString(roh, 'text/html');
          var neu = frisch.querySelector('#' + paar.el.id + ' .js-contents');
          var alt = paar.el.querySelector('.js-contents');
          if (!neu || !alt) throw new Error('js-contents fehlt in ' + paar.kennung);

          alt.innerHTML = neu.innerHTML;
        });
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function dazulegen(knopf) {
    var block = knopf.closest('[data-eng-ups]');
    if (!block || knopf.getAttribute('aria-busy') === 'true') return;

    var kugel = gewaehlte(block);
    var variantenId = kugel && kugel.getAttribute('data-id');
    if (!variantenId) return;

    var fehler = block.querySelector('[data-eng-ups-fehler]');
    var urspruenglich = knopf.textContent;

    knopf.setAttribute('aria-busy', 'true');
    knopf.textContent = 'einen Moment …';
    if (fehler) {
      fehler.textContent = '';
      fehler.hidden = true;
    }

    fetch(wurzel() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantenId), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (zustand) {
          if (!res.ok) {
            throw new Error(zustand.description || zustand.message || 'Konnte nicht hinzugefügt werden.');
          }
          return zustand;
        });
      })
      .then(function () {
        return auffrischen();
      })
      .then(function () {
        /* 04.10.2026, Werner: "er packt die tasche rein aber dann bleibt es so
           stehen". Der Knopf wurde oben auf "einen Moment ..." gesetzt und nur
           im FEHLERFALL zurueckgesetzt. Im Erfolgsfall blieb er so stehen,
           weil auffrischen() ausschliesslich `.js-contents` austauscht — und
           der Upsell liegt ausdruecklich AUSSERHALB davon (siehe Kommentar in
           sections/main-cart-footer.liquid). Er wird beim Auffrischen also nie
           neu gezeichnet und muss von Hand zurueckgesetzt werden.

           Danach die Sichtbarkeit neu rechnen: bei `wiederholen: true` bleibt
           das Angebot stehen und muss sofort wieder bedienbar sein, bei
           `false` verschwindet es. */
        knopf.textContent = urspruenglich;
        knopf.removeAttribute('aria-busy');
        sichtbarkeitPruefen();
      })
      .catch(function (err) {
        knopf.textContent = urspruenglich;
        knopf.removeAttribute('aria-busy');
        if (fehler) {
          fehler.textContent = err.message || 'Hat nicht geklappt.';
          fehler.hidden = false;
        }
      });
  }

  /* ==========================================================================
     Verdrahtung
     ====================================================================== */

  document.addEventListener('click', function (ereignis) {
    var kugel = ereignis.target.closest ? ereignis.target.closest('[data-eng-ups-kugel]') : null;
    if (kugel) {
      var block = kugel.closest('[data-eng-ups]');
      if (block) {
        kundeHatSelbstGewaehlt = true;
        waehlen(block, kugel);
      }
      return;
    }

    var knopf = ereignis.target.closest ? ereignis.target.closest('[data-eng-ups-add]') : null;
    if (knopf) {
      /* Der Link fuehrt ohne JavaScript auf die Produktseite. Mit JavaScript
         wird genau hier daraus das Dazulegen. */
      ereignis.preventDefault();
      dazulegen(knopf);
    }
  });

  document.addEventListener('keydown', function (ereignis) {
    var kugel = ereignis.target.closest ? ereignis.target.closest('[data-eng-ups-kugel]') : null;
    if (!kugel) return;

    var richtung = 0;
    if (ereignis.key === 'ArrowRight' || ereignis.key === 'ArrowDown') richtung = 1;
    if (ereignis.key === 'ArrowLeft' || ereignis.key === 'ArrowUp') richtung = -1;
    if (!richtung) return;

    var block = kugel.closest('[data-eng-ups]');
    if (!block) return;

    var ziel = nachbar(block, kugel, richtung);
    if (!ziel) return;

    ereignis.preventDefault();
    kundeHatSelbstGewaehlt = true;
    waehlen(block, ziel);
    ziel.focus();
  });

  /* ==========================================================================
     Ende der Aktion (28.09.2026, Werner)
     --------------------------------------------------------------------------
     Der Zaehler im Warenkorb steuert seit heute etwas Echtes: Laeuft er ab,
     verschwindet dieses Angebot. Damit ist "Aktion: nur jetzt" woertlich wahr
     und nicht bloss Behauptung. Reserviert wird weiterhin nichts -- der
     Warenkorb bleibt unveraendert, nur die Zugabe ist weg.

     Zwei Wege fuehren hierher:
     1. Der Zaehler laeuft bei offener Seite ab -> Ereignis von engori-cart.js.
     2. Die Seite wird neu geladen oder .js-contents ersetzt, waehrend die Zeit
        schon um ist -> beim Start nachrechnen. Startpunkt und Laufzeit stehen
        dort, wo der Zaehler sie hinterlegt: sessionStorage plus data-minuten.
     ====================================================================== */

  var TIMER_SCHLUESSEL = 'eng_cart_timer_start';

  function aktionVorbei() {
    var timer = document.querySelector('[data-eng-timer]');
    if (!timer) return false;

    var minuten = parseInt(timer.getAttribute('data-minuten'), 10);
    if (!minuten || minuten < 1) return false;

    var start;
    try {
      start = parseInt(sessionStorage.getItem(TIMER_SCHLUESSEL), 10);
    } catch (err) {
      /* Privater Modus: dann laeuft die Aktion eben weiter. Lieber ein
         Angebot zu viel als eines, das grundlos verschwindet. */
      return false;
    }

    if (!start || start > Date.now()) return false;
    return Date.now() - start >= minuten * 60 * 1000;
  }

  function aktionBeenden() {
    var block = document.querySelector('[data-eng-ups]');
    if (block) block.hidden = true;
  }

  function aktionPruefen() {
    if (aktionVorbei()) aktionBeenden();
  }

  document.addEventListener('engori:timer:abgelaufen', aktionBeenden);

  /* ==========================================================================
     Sichtbarkeit nach Stueckzahl (29.09.2026, Werner)
     --------------------------------------------------------------------------
     Der Block sitzt seit heute UNTER dem Kaufknopf, also ausserhalb von
     `.js-contents`. Das Shrine-Skript ersetzt bei einer Mengenaenderung nur
     diesen Bereich -- unser Block bliebe unveraendert stehen, auch wenn der
     Kunde die zweite Tasche wieder herausnimmt. Liquid hat ihn dann zwar mit
     der richtigen Bedingung gerendert, aber eben beim Seitenaufbau.

     Also rechnet das Skript selbst nach: Es beobachtet die Postenliste und
     liest bei jeder Aenderung /cart.js. Gezaehlt wird dieselbe Menge wie im
     Liquid -- alle Posten ausser der Zugabe selbst.
     ====================================================================== */

  var MINDESTMENGE = 2;

  function stueckOhneZugabe(korb) {
    var handle = 'engori-waistcarry-bag';
    return korb.items.reduce(function (summe, posten) {
      if (posten.handle === handle) return summe;
      return summe + posten.quantity;
    }, 0);
  }

  /* Farbe aus dem Warenkorb uebernehmen (29.09.2026, Werner: „wen der
     umgestellt wird soll er die in den upsells auch mit umstellen").

     Der Kunde hat auf der Produktseite eine Farbe gewaehlt; die Zugabe soll
     dieselbe zeigen, sofern es sie dort gibt. Die Farbnamen stimmen nicht
     zwischen allen Taschen ueberein (die LegCarry kennt „Schwarz-Tarn", die
     WaistCarry nicht) -- passt nichts, bleibt die erste Kugel stehen.

     ⚠️ Nur solange der Kunde die Zugabe nicht selbst umgestellt hat. Sonst
     spraenge seine Wahl bei jeder Mengenaenderung zurueck. */
  var kundeHatSelbstGewaehlt = false;

  function farbeAusKorb(block, korb) {
    if (kundeHatSelbstGewaehlt) return;

    var eigen = 'engori-waistcarry-bag';
    var posten = korb.items.filter(function (p) { return p.handle !== eigen; })[0];
    if (!posten || !posten.variant_title) return;

    /* Varianten koennen mehrteilig sein („Schwarz - Rechts"); vorne steht die
       Farbe, genau wie im Picker der Kaufbox. */
    var farbe = String(posten.variant_title).split(/\s[-\u2013]\s/)[0].trim();

    var treffer = kugeln(block).filter(function (k) {
      return (k.getAttribute('data-farbe') || '').trim() === farbe;
    })[0];

    if (treffer && treffer.getAttribute('aria-checked') !== 'true') {
      waehlen(block, treffer);
    }
  }

  function sichtbarkeitPruefen() {
    var block = document.querySelector('[data-eng-ups]');
    if (!block) return;
    if (aktionVorbei()) { block.hidden = true; return; }

    fetch(wurzel() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (korb) {
        block.hidden = stueckOhneZugabe(korb) < MINDESTMENGE;
        if (!block.hidden) farbeAusKorb(block, korb);
      })
      .catch(function () {
        /* Kein Netz oder unerwartete Antwort: den Block lassen, wie er ist.
           Lieber ein Angebot zu viel als ein Warenkorb, der zuckt. */
      });
  }

  /* Die Postenliste ist der zuverlaessigste Zeuge: sie wird bei jeder
     Mengenaenderung ausgetauscht, egal ob ueber unsere Knoepfe oder die des
     Themes. */
  function beobachten() {
    var liste = document.querySelector('#main-cart-items');
    if (!liste || !window.MutationObserver) return;
    var warten;
    new MutationObserver(function () {
      window.clearTimeout(warten);
      warten = window.setTimeout(sichtbarkeitPruefen, 200);
    }).observe(liste, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', sichtbarkeitPruefen);

  /* Nach jedem Nachladen des Warenkorbs erneut pruefen: das Shrine-Skript
     ersetzt .js-contents samt Block, der dann wieder sichtbar waere. */
  document.addEventListener('shopify:section:load', aktionPruefen);
  window.addEventListener('pageshow', aktionPruefen);
  function starten() {
    aktionPruefen();
    sichtbarkeitPruefen();
    beobachten();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
})();
